import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import ListLabResultsMini from '../../components/dyrejournal/listLabResultsMini';
import Versions from '../../components/versions';
import { animalAge } from '../../lib/animalAge';

@observer
class ViewAnimalIdexxResults extends Component {
    constructor(props) {
        super(props);
    }

    loadAnimal = async id => {
        const { animalStore } = this.props.stores;
        await animalStore.load(id, false, { addData: ['owners'] });
    }

    componentDidMount() {
        const { id } = this.props;
        if (id) {
            this.loadAnimal(id);
        }
    }

    render() {
        const { drawerLevel = 1 } = this.props;
        const { animalStore } = this.props.stores;
        const { animal = {} } = animalStore;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <Versions stores={this.props.stores} type='animal' id={animal?.id} key={`animal-${animal.id}`} />

                    <div class='font-weight-lighter px-3 box-header'>
                        <Text id='dyrejournal.idexx.view-all'>IDEXX results</Text> {animal?.id && <>: {animal.id}: {animal.name} ({animal.species}/{animal.breed}) {animal.birth ? animalAge(animal.birth) : ''}</>}
                    </div>

                    {animal?.isLost && <div class='alert alert-danger mx-3 my-2 d-flex align-items-center'>
                        <i class='fa-solid fa-triangle-exclamation me-2 fa-lg' />
                        <div>
                            <strong><Text id='dyrejournal.animal.isLost-banner'>This animal is reported lost!</Text></strong>
                            <div><small><Text id='dyrejournal.animal.isLost-help'>Owner has marked this animal as lost. Verify identity before any treatment.</Text></small></div>
                        </div>
                    </div>}

                    {animal?.id > 0 && <ListLabResultsMini
                        classNames='mx-1'
                        stores={this.props.stores}
                        animal={animal.id}
                        drawerLevel={drawerLevel}
                    />}

                </div>
            </div>
        );
    }
}

export default ViewAnimalIdexxResults;
